import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { cn } from '@/lib/utils';
import {
  PRE_VISIT_QUESTION_TYPE_ICON,
  PRE_VISIT_QUESTION_TYPE_ORDER,
  type PreVisitQuestionType,
} from '@/constants/preVisitQuestionTypes';

interface PreVisitQuestionTypePickerProps {
  value: PreVisitQuestionType;
  onChange: (questionType: PreVisitQuestionType) => void;
}

export function PreVisitQuestionTypePicker({ value, onChange }: PreVisitQuestionTypePickerProps) {
  const { t } = useTranslation('consultations');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {PRE_VISIT_QUESTION_TYPE_ORDER.map(function renderOption(questionType) {
        const isSelected = value === questionType;
        return (
          <button
            key={questionType}
            type="button"
            aria-pressed={isSelected}
            onClick={function pick() {
              onChange(questionType);
            }}
            className={cn(
              'flex items-start gap-2.5 p-3 rounded-xl border text-left transition-colors',
              isSelected ? 'border-zooprimary bg-zoovpalelavender' : 'border-zooborder bg-zoowhite'
            )}
          >
            <span
              className={cn(
                'w-8 h-8 rounded-lg flex items-center justify-center shrink-0',
                isSelected ? 'bg-zooprimary text-zoowhite' : 'bg-zoovpalelavender text-zooprimary'
              )}
            >
              <Icon name={PRE_VISIT_QUESTION_TYPE_ICON[questionType]} />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-bold text-zooindigo">
                {t('preVisitEditor.questionType.' + questionType)}
              </span>
              <span className="block text-xs text-zoomuted">
                {t('preVisitEditor.questionTypeDescription.' + questionType)}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
